module.exports = __webpack_public_path__ + "static/img/IE@3x.b2be3e83.jpg";